import React from 'react'
import { Box, keyframes } from '@mui/material'

const pulse = keyframes`
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.7; }
`

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`

type Props = {
  variant?: 'text' | 'rectangular' | 'circular'
  width?: number | string
  height?: number | string
  sx?: object
}

export default function Skeleton({ variant = 'rectangular', width = '100%', height = 20, sx }: Props) {
  const isCircular = variant === 'circular'

  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: isCircular ? '50%' : 1,
        background: 'linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%)',
        backgroundSize: '200% 100%',
        animation: `${shimmer} 1.5s ease-in-out infinite`,
        ...sx
      }}
    />
  )
}

export function FileRowSkeleton() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        p: 1.5,
        borderBottom: '1px solid #f0f0f0'
      }}
    >
      <Skeleton variant="circular" width={40} height={40} />
      <Box sx={{ flex: 1 }}>
        <Skeleton width="60%" height={16} sx={{ mb: 0.5 }} />
        <Skeleton width="30%" height={12} />
      </Box>
      <Skeleton width={80} height={14} />
      <Skeleton width={60} height={14} />
    </Box>
  )
}

export function FileGridSkeleton() {
  return (
    <Box
      sx={{
        bgcolor: '#fff',
        borderRadius: '0 0 12px 12px',
        border: '1px solid #e0e0e0',
        overflow: 'visible',
      }}
    >
      {/* Bloco superior — área do ícone (topo reto, sem border-radius) */}
      <Box
        sx={{
          height: 120,
          bgcolor: '#f8f9fa',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Skeleton variant="circular" width={48} height={48} />
      </Box>

      {/* Bloco inferior — textos (base arredondada) */}
      <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Skeleton width="85%" height={14} />
        <Skeleton width="50%" height={12} />
        <Skeleton width="65%" height={12} />
      </Box>
    </Box>
  )
}
